import React from "react";
import * as yup from "yup";
import { Form, Formik, FormikProps } from "formik";
import { DatePicker } from "@mui/x-date-pickers";
import { Grid } from "@mui/material";
import { gql, useQuery } from "@apollo/client";
import { Modal } from "components/haven-design";
import Development from "components/development";
import { Button } from "components/haven-design/buttons";
import { MultiSelect as MultiSelectBox } from "components/haven-design/form";
import { DialogActions, DialogContent } from "components/haven-design/modal/dialog";
import { RequestFormsLookup, RequestFormsLookupVariables } from "types/gql-types";
import styles from "../../actions.module.css";
import { Contact, ContactPicker } from "./contact-picker";


type Props = {
  propertyId: string;
  interestId: string;
  isOpen: boolean;
  onSubmit: () => void;
  onRequestClose: () => void;
  onCancel: () => void;
}

const FORMS_QUERY = gql`
  query RequestFormsLookup($propertyId: ID!) {
    property(id: $propertyId) {
      id
      forms {
        id
        formDefinition {
          name
        }
      }
    }
  }
`;

const formOptions = [
  { id: "12345", value: "12345", label: "Full Application - Bluff View Full Application", name: "Full Application - Bluff View Full Application" },
  { id: "12346", value: "12346", label: "Affidavit - Child Support", name: "Affidavit - Child Support" },
  { id: "12347", value: "12347", label: "Affidavit - Self-Employed", name: "Affidavit - Self-Employed" },
];

const addressOptions:Contact[] = [
  { name: "Applicant - Jane Doe", mobile: "(555) 555-7171", userEmail: "jane_also@gmail.com", userMobile: "(555) 555-6060", type: "applicant" },
  { name: "Household Member - Tom Smith", email: "tom@gmail.com", mobile: "(555) 555-8282" },
  { name: "Household Member - Pete Jones", email: "pete@gmail.com", mobile: "(555) 555-9393" },
];
type RequestFormsFormProps = FormikProps<{
  contacts: never[];
  forms: never[];
  deadline: null;
}>

const RequestFormsForm: React.FC<RequestFormsFormProps> = ({ values, setFieldValue }) => (
  <Form id="request-forms">
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <ContactPicker name="contacts" options={addressOptions} selected={values.contacts} />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <DatePicker
          slotProps={{
            textField: {
              style: { minWidth: "15em" },
              name: "deadline",
              autoComplete: "off",
              size: "small",
              variant: "outlined",
              label: "Deadline",
            },
            inputAdornment: { position: "end" },
          }}
          disablePast
          closeOnSelect
          format="MM/dd/yyyy"
          value={values.deadline}
          onChange={(date: Date | null) => {
            setFieldValue("deadline", date);
          }} />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <MultiSelectBox name="forms" label="Select forms:" options={formOptions} selectedOptions={values.forms} />
      </Grid>
    </Grid>
  </Form>);

const requestFormsSchema = yup.object({
  contacts: yup.array(),
});

// eslint-disable-next-line max-lines-per-function
const RequestFormsModal: React.FC<Props> = ({
  isOpen,
  onRequestClose,
  onSubmit,
  propertyId,
}) => {
  const { data } =
  useQuery<RequestFormsLookup, RequestFormsLookupVariables>(FORMS_QUERY, {
    variables: { propertyId },
  });
  return (
    <Modal
      title="Request Forms"
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <Formik
        initialValues={{ contacts: [], forms: [], deadline: null }}
        validationSchema={requestFormsSchema}
        onSubmit={() => {
        // console.log("Submit!");
        // console.log(values);
          onSubmit();
        }}
      >
        {(formikProps) => (<>
          <DialogContent>
            <RequestFormsForm {...formikProps} />
            <Development>
              <div>data: {JSON.stringify(data)}</div>
              <div>errors: {JSON.stringify(formikProps.errors)}</div>
              <div>values: {JSON.stringify(formikProps.values)}</div>
            </Development>
          </DialogContent>
          <DialogActions>
            <Button
              className={styles.confirmationButton}
              color="secondary"
              size="S"
              onClick={onRequestClose}
              disabled={formikProps.isSubmitting}
            >
            Cancel
            </Button>
            <Button
              form="request-forms"
              type="submit"
              className={styles.confirmationButton}
              color="primary"
              size="S"
              disabled={formikProps.isSubmitting}
            >
              {formikProps.isSubmitting ? "Submitting" : "Confirm"}
            </Button>
          </DialogActions>

        </>
        )}
      </Formik>
    </Modal>
  );
};

export default RequestFormsModal;
